import { showToast } from "./toast-config";

const warningToast = (message = "Warning", options) =>
  showToast("warning", message, "Warning", options);

export default warningToast;
